export const promotionalVideosList = [
    {
        title: "ESPN / THE UNDEFEATED",
        meta: "Featured Guest",
        url: " https://vimeo.com/534670533/a1e11cb0e8",
    },
    {
        groupTitle: "PHARRELL’S TEAM YELLOW & WARBY PARKER – HOST",
        groupItems: [
            {
                title: "Videos",
                url: "https://bit.ly/2QEBJDy",
            },
            {
                title: "About the Project",
                url: "http://bit.ly/3dytsdi",
            },
        ]
    },
    {
        title: "UPWORK VOICES OF AUTHORITY",
        url: "https://buff.ly/2UFni0W",
    },
    {
        title: "PDX PHILANTHROPY - RIP CITY...RISE UP!",
        url: "http://riseuppdx.com/",
    },
    {
        groupTitle: "“THE KATALYST” CONFECTIONS FOR THE CURIOUS SOUL",
        groupItems: [
            {
                title: "Episode 1 WELCOME!",
                url: "http://youtu.be/U6QBSxqjfMk",
            },
            {
                title: "Episode 2 OH THE PLACES…",
                url: "http://youtu.be/BtC1vsRNRGM",
            },
            {
                title: "Episode 7 FOREVER YOUNG!",
                url: "http://youtu.be/KGeHf0F3UMI",
            },
            {
                title: "Episode 8 FEET DON’T FAIL ME NOW!",
                url: "http://youtu.be/W14WoNE1dbg",
            }

        ]
    },
    {
        title: "CREATIVE MORNINGS",
        meta: "Vancouver, BC / 2020",
        url: "https://creativemornings.com/talks/kevin-carroll-online/1",
    },
    {
        title: "CREATIVE MORNINGS",
        meta: "Portland, OR / 2015",
        url: "http://bit.ly/1JdWaXB",
    },
    {
        title: "FIRST TECH FEDERAL CREDIT UNION",
        url: "https://vimeo.com/503191219",
    },
    {
        title: "FIRST TECH FEDERAL CREDIT UNION — MEMBER SPOTLIGHT",
        url: "https://www.youtube.com/watch?v=t5ddaoX9ws8",
    },
    {
        groupTitle: "THE ART OF SPORT + PLAY: EXHIBIT IMAGES",
        groupItems: [
            {
                title: "SAM NOBLE MUSEUM",
                url: "http://www.flickr.com/photos/katatlarge/sets/72157641910135964/",
                meta: "Norman, OK / Oct. 2013- Jan. 2014",
            },
            {
                title: "MERCY CORPS",
                url: "http://www.flickr.com/photos/katatlarge/sets/72157641907976033/",
                meta: "Portland, OR / Apr. - Aug. 2013",
            },
            {
                title: "CENTER OF CREATIVE ARTS (COCA)",
                url: "https://www.flickr.com/photos/katatlarge/sets/72157643235323054/",
                meta: "St. Louis, MO / Jul.- Sep. 2012",
            },
        ]
    },
    {
        groupTitle: "MODA HEALTH – COMMUNITY CATALYST FOR MODA HEALTH",
        groupItems: [
            {
                title: "RIP CITY RELAY",
                url: "http://bit.ly/1b1Xz62",
            },
            {
                title: "KC’s FIRST MODA HEALTH COMMERCIAL",
                url: "http://youtu.be/-ydE4JOYlvM",
            },
            {
                title: "KC’s LATEST MODA HEALTH AD",
                url: "http://www.youtube.com/watch?v=4-ANzHYzhj0&list=HL1393895535",
            },
        ]
    },
    {
        title: "Where DREAMS and Reality Meet!",
        meta: "2012",
        url: "http://m.youtube.com/watch?v=wSvr0P8xrG4",
    },
    {
        title: "NIKE CHI - TALK",
        meta: "Chicago, IL / 2014",
        url: "http://bit.ly/1Ug1Bw3",
    },
    {
        title: "KOBE BRYANT + KC Interview – Aspen Project Play Summit",
        meta: "2018",
        url: "https://vimeo.com/516933456/0ce997c1db",
    },
    {
        title: "A Kids Book About...BELONGING",
        url: "https://vimeo.com/581793868/cc4e74e38d",
    },
];